<template>
    <div>
        <card-header :title="company" :subheader="typeLabel" icon="fa-building"/>

        <card-body>
            <card-toolbar>
                <button @click="$openCard('new-directory-contact', {type: props.type, companyKey: props.companyKey}, card)">
                    <i class="fas fa-plus mr-2"/>New Contact
                </button>
            </card-toolbar>
            <card-list>
                <!-- What's true of the company as a whole, read off its
                     contacts: the first record with each detail wins. -->
                <subheader-list-item title="Company" icon="fa-building"/>
                <data-row title="Type"><b-tag>{{ typeLabel }}</b-tag></data-row>
                <data-row title="Website" v-if="facts.website">
                    <a :href="facts.website" target="_blank" rel="noopener">{{ facts.website }}</a>
                </data-row>
                <data-row title="Address" v-if="facts.address">
                    <span style="white-space: pre-line">{{ facts.address }}</span>
                </data-row>
                <data-row title="City" v-if="facts.city">{{ facts.city }}</data-row>
                <data-row title="Country" v-if="facts.country">{{ facts.country }}</data-row>

                <subheader-list-item title="People" icon="fa-user" :badge="contacts.length"/>
                <contact-list-item
                    :card="card"
                    :contact="c"
                    lead="name"
                    v-for="c in contacts"
                    :key="c.id"
                    :active="child && child.definition.component === 'contact' && String(child.props.contactId) === String(c.id)"
                    @click="$openCard('contact', {contactId: c.id}, card)"
                />
                <container-list-item padded v-if="!contacts.length">
                    <p class="has-text-grey is-size-7 my-2">No contacts at this company.</p>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../TIER/components/CardHeader";
    import CardList from "../../TIER/components/CardList";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";
    import ContactListItem from "@/components/ContactListItem";
    import {client as http} from "@/http_client";
    import {typeLabel, companyFromKey} from "@/components/contact_meta";

    // Company-level details, in the order they're shown.
    const FACTS = ['website', 'address', 'city', 'country'];

    /**
     * One company within a type: the people there. The company is nothing
     * but the string on its contacts (there is no companies table), so the
     * card is addressed by type + encoded name and reads its details off the
     * contacts it lists.
     */
    export default {
        name: "ContactCompany",
        props: ['card', 'child', 'props'],
        components: {
            ContactListItem, DataRow, ContainerListItem, SubheaderListItem,
            CardToolbar, CardBody, CardList, CardHeader
        },
        data: function () {
            return {
                contacts: []
            };
        },
        computed: {
            company: function () {
                return companyFromKey(this.props.companyKey);
            },
            typeLabel: function () {
                return typeLabel(this.props.type);
            },
            facts: function () {
                const facts = {};
                FACTS.forEach(key => {
                    const holder = this.contacts.find(c => c[key]);
                    if (holder) facts[key] = holder[key];
                });
                return facts;
            }
        },
        methods: {
            load(force) {
                // The breadcrumb reads the company, not "Company".
                this.$emit('title', this.company);
                this.$emit('loading', true);
                http.get('/api/contacts?type=' + encodeURIComponent(this.props.type)
                    + '&company=' + encodeURIComponent(this.company), {force}).then(response => {
                    this.contacts = response.data || [];
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                this.load(true);
            }
        },
        watch: {
            'props.companyKey': function () {
                this.load(true);
            },
            // TIER rebuilds its card objects (title and all) on every route
            // change, so the breadcrumb forgets the title whenever a child
            // opens. Re-say it.
            card: function () {
                this.$emit('title', this.company);
            }
        },
        mounted() {
            this.load();
        }
    };
</script>
